import React, { useState } from 'react';
import classnames from 'classnames';
import BottleLoadingImage from 'images/bottle-loading-image.jpg';
import BottleLoadingImageLarge from 'images/bottle-loading-image-large.jpg';
import { relative } from 'scy/position.mod.scss';
import { clickable } from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';

function Img({
  product = {},
  large,
  loading,
  onClick,
  className,
  ...restProps
}) {
  const [hasError, setHasError] = useState(false);
  const imageSrc = large ? product.image_large : product.image;
  const fallbackSrc = large ? BottleLoadingImageLarge : BottleLoadingImage;
  const src = loading || hasError || !imageSrc ? fallbackSrc : imageSrc;

  return (
    <img
      src={src}
      className={classnames(className, {
        [clickable]: !!onClick
      })}
      onClick={onClick}
      onError={() => setHasError(true)}
      {...restProps}
    />
  );
}

const ProductImage = props => {
  return (
    <div className={relative}>
      <Img {...props} />
    </div>
  );
};

const ContainerProductImage = ({ children, className, ...props }) => {
  return (
    <div className={classnames(relative, className)}>
      <Img {...props} />
      {children}
    </div>
  );
};

const LargeProductImage = props => <ProductImage large {...props} />;

const ThumbnailProductImage = ({ product, className, ...rest }) => (
  <Img
    product={product}
    title={`${product.title} ${product.subtitle}`}
    className={classnames(styles.thumbnail, className)}
    {...rest}
  />
);

export {
  ProductImage,
  LargeProductImage,
  ThumbnailProductImage,
  ContainerProductImage
};
